import { render, staticRenderFns } from "./AccountStatement.vue?vue&type=template&id=7db3fa72&scoped=true"
import script from "./AccountStatement.vue?vue&type=script&lang=js"
export * from "./AccountStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db3fa72",
  null
  
)

export default component.exports